export default __webpack_public_path__ + "static/media/add-disabled.57abca65.svg";